<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Motivo de no liquidar</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-select formControlName="noMedicalFeeReason" placeholder="Motivo de no liquidar" required>
                <mat-option *ngFor="let noMedicalFeeReason of noMedicalFeeReasons" [value]="noMedicalFeeReason">
                    {{ noMedicalFeeReason.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.noMedicalFeeReason.errors && f.noMedicalFeeReason.errors.required">
                Seleccione un motivo
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <textarea formControlName="observations" matInput placeholder="Observaciones"></textarea>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>